import React from 'react';
import CustomButton from '../ui/Button';
import { useTranslation } from "react-i18next";



const MissionStatement = () => {
    const { t } = useTranslation("about"); // Hook to use translations

    return (
        <div className="relative mx-auto px-[30px] max-w-[1220px] flex flex-col md:flex-row items-center">
            <div className="flex flex-col md:flex-row items-center w-full mt-[53px] mb-[70.45px]">
                {/* Left Section with Card */}
                <div className="w-full md:w-1/2 mb-8 md:mb-0 h-[581px] ">
                    <div className="relative rounded-tl-xl rounded-tr-none rounded-br-none rounded-bl-none overflow-hidden shadow-lg h-full">
                        <img
                            src="/assets/supporting.png"
                            alt="Safety Work Environment"
                            className="w-[514px] h-[581px] object-cover transition-transform duration-700 ease-in-out transform hover:scale-125 delay-75"
                        />
                    </div>
                </div>

                {/* Right Section with Text */}
                <div className="w-full md:w-1/2 text-white flex flex-col justify-center md:pl-10">
                    <div className="py-6">
                        <span className='title-small text-[#05897E] font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit' > {t("safety_first")}</span>

                    </div>
                    <h2 className="web-heading-card-3 mb-4 py-2">{t("mission_statement")}</h2>
                    <p className="body-large-2 text-color mb-4 py-2">
                        {t("mission_description")}
                    </p>
                    <a href="/safety_management">
                        <CustomButton className='w-fit'>    {t("explore_safety_solutions")}</CustomButton>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MissionStatement;